import { useState, useCallback, useEffect } from 'react';

export interface RecentProduct {
    id: string;
    name: string;
    price_per_unit: number;
    images: string[];
    slug: string;
    category_name?: string;
}

const STORAGE_KEY = 'recent-products';
const MAX_RECENT = 10;

export const useRecentProducts = () => {
    const [recentProducts, setRecentProducts] = useState<RecentProduct[]>([]);

    useEffect(() => {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
            try {
                setRecentProducts(JSON.parse(stored));
            } catch (e) {
                console.error('Failed to parse recent products', e);
            }
        }
    }, []);

    const addProduct = useCallback((product: RecentProduct) => {
        setRecentProducts((prev) => {
            const filtered = prev.filter((p) => p.id !== product.id);
            const updated = [product, ...filtered].slice(0, MAX_RECENT);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
            return updated;
        });
    }, []);

    const clearRecent = useCallback(() => {
        localStorage.removeItem(STORAGE_KEY);
        setRecentProducts([]);
    }, []);

    return {
        recentProducts,
        addProduct,
        clearRecent,
    };
};
